import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const NAV_REFERENCE = [
  { label: "Index", path: "/index" },
  { label: "Companies", path: "/reference" },
  { label: "Example Use Case", path: "/reference/use-case" },
];

const NAV_COT = [
  { label: "Index", path: "/index" },
];

const NAV_TREASURY = [
  { label: "Index", path: "/index" },
];

export default function ReferenceHeader() {
  const location = useLocation();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  const isCot = location.pathname.startsWith("/cot");
  const isTreasury = location.pathname.startsWith("/treasury");
  const NAV_ITEMS = isTreasury ? NAV_TREASURY : isCot ? NAV_COT : NAV_REFERENCE;

  const handleNav = (path) => {
    navigate(path);
    setMenuOpen(false);
  };

  return (
    <header
      style={{
        position: "sticky",
        top: 0,
        zIndex: 50,
        background: "var(--pord-bg, #222518)",
        borderBottom: "1px solid rgba(184,212,208,0.06)",
        padding: "0 24px",
      }}
    >
      <div
        style={{
          maxWidth: 1280,
          margin: "0 auto",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          height: 64,
        }}
      >
        {/* Brand */}
        <button
          onClick={() => handleNav("/index")}
          style={{
            fontFamily: "'DM Sans', sans-serif",
            fontWeight: 400,
            fontSize: "1.4rem",
            color: "var(--pord-teal, #b8d4d0)",
            background: "none",
            border: "none",
            cursor: "pointer",
            padding: 0,
            letterSpacing: "-0.02em",
            flexShrink: 0,
          }}
          data-testid="ref-header-brand"
        >
          Pord.
        </button>

        {/* Desktop nav */}
        <nav className="ref-nav-desktop" style={{ display: "flex", gap: 8, alignItems: "center" }}>
          {NAV_ITEMS.map((item) => {
            const isActive = location.pathname === item.path;
            return (
              <button
                key={item.path}
                onClick={() => handleNav(item.path)}
                data-testid={`ref-nav-${item.path.split("/").pop() || "companies"}`}
                style={{
                  fontFamily: "'DM Sans', sans-serif",
                  fontSize: "11px",
                  fontWeight: 400,
                  textTransform: "uppercase",
                  letterSpacing: "0.14em",
                  padding: "9px 18px",
                  borderRadius: 999,
                  border: isActive ? "1px solid var(--pord-teal, #b8d4d0)" : "1px solid rgba(184,212,208,0.18)",
                  background: isActive ? "rgba(184,212,208,0.08)" : "transparent",
                  color: isActive ? "var(--pord-teal, #b8d4d0)" : "rgba(255,255,255,0.6)",
                  cursor: "pointer",
                  transition: "all 200ms ease",
                  whiteSpace: "nowrap",
                }}
              >
                {item.label}
              </button>
            );
          })}
        </nav>

        {/* Mobile menu toggle — shows current page name */}
        <button
          className="ref-nav-mobile-toggle"
          onClick={() => setMenuOpen(!menuOpen)}
          style={{
            display: "none",
            background: "none",
            border: menuOpen ? "1px solid rgba(184,212,208,0.3)" : "1px solid rgba(184,212,208,0.18)",
            borderRadius: 999,
            cursor: "pointer",
            padding: "8px 16px",
            color: "var(--pord-teal, #b8d4d0)",
            fontFamily: "'DM Sans', sans-serif",
            fontSize: "11px",
            fontWeight: 400,
            textTransform: "uppercase",
            letterSpacing: "0.14em",
            alignItems: "center",
            gap: 8,
          }}
          data-testid="ref-mobile-menu-btn"
        >
          {NAV_ITEMS.find(i => i.path === location.pathname)?.label || "Menu"}
          <span style={{ fontSize: "8px", marginLeft: 4 }}>{menuOpen ? "▲" : "▼"}</span>
        </button>
      </div>

      {/* Mobile dropdown */}
      {menuOpen && (
        <div
          className="ref-nav-mobile-menu"
          style={{
            padding: "8px 0 16px",
            display: "flex",
            flexDirection: "column",
            gap: 8,
          }}
        >
          {NAV_ITEMS.map((item) => {
            const isActive = location.pathname === item.path;
            return (
              <button
                key={item.path}
                onClick={() => handleNav(item.path)}
                style={{
                  fontFamily: "'DM Sans', sans-serif",
                  fontSize: "12px",
                  fontWeight: 400,
                  textTransform: "uppercase",
                  letterSpacing: "0.14em",
                  padding: "12px 16px",
                  borderRadius: 10,
                  border: "none",
                  background: isActive ? "rgba(184,212,208,0.08)" : "transparent",
                  color: isActive ? "var(--pord-teal, #b8d4d0)" : "rgba(255,255,255,0.6)",
                  cursor: "pointer",
                  textAlign: "left",
                }}
              >
                {item.label}
              </button>
            );
          })}
        </div>
      )}
    </header>
  );
}
